import { runSmartSubnav } from '../../snippets/smart-subnav/smart-subnav';
import { visitOnScroll } from '../../scripts/utils/visitOnScroll';
import './smart-lighting-control-dimmer-switch/smart-lighting-control-dimmer-switch';
import { initWhereInstalledSlider } from './smart-lighting-control-where-installed/smart-lighting-control-where-installed';
import { initVideoAutoplayControls } from '../../scripts/utils/videoAutoplayControls/videoAutoplayControls';
import { initInstallationSlider } from '../../snippets/installation-slider/installation-slider';

runSmartSubnav({
  intersectionThreshold: 0.6,
  intersectionRatio: 0.6,
});
initVideoAutoplayControls();
visitOnScroll();
initInstallationSlider();
initWhereInstalledSlider();
